import { render, staticRenderFns } from "./studentBG.vue?vue&type=template&id=5ddaf907&scoped=true&"
import script from "./studentBG.vue?vue&type=script&lang=js&"
export * from "./studentBG.vue?vue&type=script&lang=js&"
import style0 from "./studentBG.vue?vue&type=style&index=0&id=5ddaf907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddaf907",
  null
  
)

export default component.exports